import React, { Component } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import Message from '@material-ui/icons/Message';

import IconButton from '@material-ui/core/IconButton';

class ChatButton extends Component {
    componentDidMount() {
        this.setState({ open: false });
    }
    _openChat = () => {
        this.props.popup && this.props.popup.show();
        this.setState({open: true});
    }
    _closeChat = () => {
        this.props.popup && this.props.popup.hide();
        this.setState({open: false});
    }
    render() {
        
        return this.props.popup ? 
        <IconButton className="ckp-chat-button" onClick={this.state.open ? this._closeChat : this._openChat} color="inherit">
            {this.state.open ? <CloseIcon /> : <Message />}
        </IconButton> : null;
    }
}

export default ChatButton;



// WEBPACK FOOTER //
// ./src/components/application/events/ChatButton.js